module.exports = __webpack_public_path__ + "static/media/logo.7915a4ab.svg";